module.exports = __webpack_public_path__ + "static/media/inspiration-alt.a42ed1f4.svg";